
import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import "./totalcard.scss";
import { title } from "process";

// interface to declare all our prop types
interface Props {
  children: React.ReactNode;
  title: any;
}

const InfoCard: React.FC<Props> = ({
  children,
  title,
  ...rest
}) => {
  
  return (

    <div className="totalCard"> 
        <h3>{title}</h3>
        {children}
    </div>
  );
};

export default InfoCard;
